/**
 * @file コンポーネント：フル動画ページスレッドポップアップ一覧ページ ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnHandleApiErrors, fnHandleApiSuccess } from "~/src/functions/common";

// コンポーネントを返す
export const PopupThreadList = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    /**
     * 変数
     */
    const numDisplay = 10; // スレッドの表示数

    /**
     * 状態管理
     */
    const [allThreadCount, setAllThreadCount] = useState(null); // 総スレッド数
    const [isListThreadLoaded, setIsListThreadLoaded] = useState(false); // スレッド一覧の取得が完了したかどうか
    const [listThread, setListThread] = useState(null); // スレッド一覧データ
    const [paginationCurrentPage, setPaginationCurrentPage] = useState(1); // 現在のページネーションの位置
    const [paginationlist, setPaginationlist] = useState([]); // ページネーションリスト
    const [threadSortType, setThreadSortType] = useState("replyDate"); // ソートタイプ

    /**
     * 要素参照
     */
    const refContainer = useRef(null);

    /**
     * ポップアップ見出し設定
     */
    useEffect(() => {
        if (isListThreadLoaded) {
            props.setPopupHeadline(
                localized["Label.ThreadList"] + " (" + allThreadCount + ")"
            );
        }
    }, [allThreadCount, props.currentPage]);

    /**
     * ポップアップがクローズされた時の処理
     */
    useEffect(() => {
        setPaginationCurrentPage(1);
        setThreadSortType("replyDate");
        fnGetThreadList();
    }, [props.isOpenPopupThread]);

    /**
     * スレッドの新規作成、削除が成功した時の処理
     */
    useEffect(() => {
        if (props.messageList) {
            if (refContainer.current) {
                refContainer.current.scrollTop = 0;
            }
            setPaginationCurrentPage(1);
            setThreadSortType("replyDate");
            fnGetThreadList();
        }
    }, [props.messageList]);

    /**
     * スレッド一覧データの再取得
     */
    useEffect(() => {
        fnGetThreadList();
    }, [paginationCurrentPage, threadSortType]);

    /**
     * ページネーション設定
     */
    useEffect(() => {
        if (allThreadCount) {
            const tempListPagination = [];
            // ページ数設定
            const pageCount = Math.ceil(allThreadCount / numDisplay);

            for (let i = 0; i < pageCount; i++) {
                const item = {
                    href: "#",
                    isCurrent: i + 1 === paginationCurrentPage ? true : false,
                    onClick: (e) => {
                        e.preventDefault();
                        setPaginationCurrentPage(i + 1);
                        fnClearMessage();
                    },
                };
                tempListPagination.push(item);
            }
            setPaginationlist(tempListPagination);
        }
    }, [allThreadCount, paginationCurrentPage]);

    /**
     * ソートタイプが更新時、カレントページを1にする
     */
    useEffect(() => {
        setPaginationCurrentPage(1);
    }, [threadSortType]);

    /**
     * ソートタイプの変更
     */
    const fnChangeSortType = (e) => {
        setThreadSortType(e.target.options[e.target.selectedIndex].value);
    };

    /**
     * メッセージのクリア
     */
    const fnClearMessage = () => {
        props.setErrorMessageList(null);
        props.setMessageList(null);
    };

    /**
     * スレッド一覧データ取得
     */
    const fnGetThreadList = (
        operationId = props.operationId,
        sortType = threadSortType,
        limit = numDisplay,
        offset = numDisplay * paginationCurrentPage - numDisplay
    ) => {
        const api =
            "/api/threads/" +
            operationId +
            "/" +
            sortType +
            "/" +
            limit +
            "/" +
            offset;
        fetch(api)
            .then(fnHandleApiErrors)
            .then(fnHandleApiSuccess)
            .then((result) => {
                // 200 OK
                if (result !== null) {
                    const tempListThread = result.threaList.map((thread) => {
                        const tempThread = {
                            context: thread.context,
                            createdAt: thread.createdAt,
                            dateTimeAgo: props.fnGetDatetimeAgo(
                                thread.createdAt
                            ),
                            isOwner: thread.isOwner,
                            isPublic: thread.isPublic,
                            replyCount: thread.replyCount,
                            threadId: thread.threadId,
                            title: thread.title,
                            userName: thread.userName,
                        };
                        return tempThread;
                    });
                    setListThread(tempListThread);
                }
                // 204 No Content
                if (result === null) {
                    setListThread(null);
                }
                setAllThreadCount(result ? result.allThreadCount : 0);
                setIsListThreadLoaded(true);
            })
            .catch((error) => {
                props.setErrorMessageList(
                    localized["Message.FailGetThreadList"]
                );
                console.error(error);
                setIsListThreadLoaded(true);
            });
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnChangeSortType={fnChangeSortType}
            fnClearMessage={fnClearMessage}
            isListThreadLoaded={isListThreadLoaded}
            listThread={listThread}
            paginationlist={paginationlist}
            refContainer={refContainer}
        />
    );
};
